import { Injectable } from '@angular/core';
import { Resolve } from '@angular/router';
import { Observable, zip } from 'rxjs';
import { map } from 'rxjs/operators';

import { ConfiguracaoCaixaApiService } from '../configuracao-caixa/services/configuracao-caixa-api.service';
import { TipoLancamentoApiService } from '@services/tipo-lancamento-api.service';
import { RegraConciliacaoAutomaticaResolverData } from './models/regra-conciliacao-automatica-resolver-data';

@Injectable()
export class RegraConciliacaoAutomaticaResolver implements Resolve<RegraConciliacaoAutomaticaResolverData> {

  constructor(
    private configuracaoCaixaApiService: ConfiguracaoCaixaApiService,
    private tipoLancamentoApiService: TipoLancamentoApiService,
  ) { }

  resolve(): Observable<RegraConciliacaoAutomaticaResolverData> {
    return zip(
      this.configuracaoCaixaApiService.getContasCaixa(),
      this.tipoLancamentoApiService.getTiposLancamento(),
    ).pipe(
      map(([contas, tipos]) => ({
        contas,
        tiposDestino: tipos.map(t => ({ id: t.id, nome: `${t.nome} (${t.nomeConta})` })),
      }))
    );
  }
}
